// import httpUtil from "../assets/script/utils/http";
import httpUtil from "../assets/script/utils/http";
import { saveDoc } from "../assets/script/model";

const state = {
  insertHtml: "",
  allContent: "",
  contentCount: 0,
  contentPic: 0,
  sentence: "",
  isOriginal: false,
  isShowLoading: false,
  isSaveLength: 640,
  isSaveNum: 0,
  insertDoc: new saveDoc(),
  isSaveState: true
};

const mutations = {
  setSaveLength(state, length) {
    state.isSaveLength = length;
    state.isSaveNum += 1;
  },
  setisSaveState(state, states) {
    state.isSaveState = states;
  }
};

const actions = {
  //保存文章
  ADocInsert(ctx, params) {
    return httpUtil.post("/ai/DocSave", params);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
